import styled, { css } from 'react-emotion'

export const container = css`
  // position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100;
  min-height: 100vh;
  border-radius: 5px;
  margin: 0 auto;
`

export const fixedContainer = css`
  display: block;
  width: 100%;
  margin: 0 auto;
  max-width: 95vw;

 h3 {
  color: #6f6f6f;
  font-size: 1.42rem;
  }

  @media screen and (max-width: 640px) {
    max-width: 100vw;
    margin: 0 0 0 1rem;

    h3 {
      color: #6f6f6f;
      font-size: 15px;
      margin: 0 1rem;
    }
  }
}
`

export const carouselMargin = css`
  div.slider-frame {
    margin: 0 !important;
  }

  @media screen and (max-width: 640px) {
    div.slider-frame {
      // padding: 0 1rem !important;
      margin: 0 !important;
    }
  }
`

export const DummyPlaceholder = styled('div')`
  height: auto;

  /* width: 40vw; */
  border-radius: 0.25rem;
  animation: pulse ${props => props.num + 1}s infinite ease-in-out;


  &:hover {
    cursor: pointer;
  }

  img.bannerImage {
    position: relative;
    z-index: 1;
    opacity: 0;
    width: 100%;
    height: 100%;
  }

  img.bannerImage3d {
    position: relative;
    z-index: 1;
    width: 40vw;
    opacity: 0;
  }

  @keyframes pulse {
    0% {
      background-color: rgba(165, 165, 165, 0.1);
    }

    50% {
      background-color: rgba(165, 165, 165, 0.3);
    }

    100% {
      background-color: rgba(165, 165, 165, 0.1);
    }
  }
`

export const DummyWithoutAnimationPlaceholder = styled('div')`
  height: auto;
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 0.25rem;
  transition: all ease 500ms;
  min-height: 38rem;

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 640px) {
    min-height: 120px;
  }

  .fallbackImg {
    width: 100%;
    height: 100%;
  }

  .bannerImage {
    position: relative;
    z-index: 1;
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .bannerImage3d {
    position: relative;
    z-index: 1;
    width: 40vw;
    opacity: 1;

    @media screen and (max-width: 640px) {
      width: 77.5vw;
    }
  }
`

export const CarouselWrapper = styled('div')`
  padding: 1rem 0 0 !important;
  margin: -10px 0 0;

  .slider-frame {
    padding: 0 !important;
    overflow: visible !important;
  }

  .slider-control-centerright {
    right: -2.5% !important;
  }

  .slider-control-centerleft {
    left: -2.5% !important;
  }
  
  .imageWrapper.loaded {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 1024px) {
    // min-height: 14rem;

    .slider-control-centerright {
      right: -2.5rem!important;
    }

    .slider-control-centerleft {
      left: -2.5rem!important;
    }

    .slider-control-centerleft .arrowWrapper {
      left: -0.5rem;
    }

    .slider-control-centerright .arrowWrapper {
      right: 0;
    }

    .slider-control-centerright span {
      right: -1.2rem;
    }
  }

  @media screen and (max-width: 640px) {
    // min-height: 14rem;
    padding: 1rem 0.5rem 0 !important;
    
    .slider-control-centerright {
      right: -2.5rem!important;
    }

    .slider-control-centerright .arrowWrapper {
      right: 0;
    }

    .slider-control-centerleft .arrowWrapper {
      left: -0.7rem;
    }

    .slider-control-centerleft {
      left: -2.5rem!important;
    }

    .slider-control-centerright span,
    .slider-control-centerleft span {
      width: 1.5rem;
    }

    .slider-control-centerright span {
      right: 0;
    }
  }

  @media screen and (min-width: 1600px) {
    .slider-control-centerright {
      right: -1.8% !important;
    }

    .slider-control-centerleft {
      left: -1.8% !important;
    }
  }

  @media screen and (min-height: 1079px) {
    .slider-slide {
      margin: auto 1.2rem!important;
    }
  }
`